import { api } from '../Configs/AxiosConfigs'
import { defineCancelApiObject } from '../Configs/AxiosUtils'

export const EventApis = {
  createEvent: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },

  loadEventsPostedByLoggedInUser: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/posted/${reqObj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  loadAllPostedEvents: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/all/posted/paginated/view`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  loadAllSuggestedEventsForLoggedInUser: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/all/view/${reqObj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  AllEvents: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/all/paginated/view`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getEventsByEventId: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/view`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  loadAnEventByUsingEventId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/${uploadImgObj.eventId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getAllGoingEventsForUser: async function (userobj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/all/viewgoing/${userobj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userobj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  setGoingForAnEventForUser: async function (userobj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/going`,
      method: 'put',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userobj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  setNotGoingForAnEventForUser: async function (userobj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/notgoing`,
      method: 'put',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userobj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },

  cancelEventByUsingEventId: async function (reqObj, cancel = false) {
    const response = await api.request({
      url: `/v1/event/cancel`,
      method: 'put',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },

  updateEvent: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/update`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  //interested selected
  eventSelectInterestedEventId: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/interested`,
      method: 'put',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  eventsSavedPastUserId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/saved/past/${uploadImgObj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  // eventsSavedPastUserId: async function (uploadImgObj, cancel = false) {
  //   console.log(`UpdateImageObject`, uploadImgObj)

  //   // let headerVal = { "content-type": "multipart/form-data" }
  //   const response = await api.request({
  //     url: `/v1/events/saved/past/${uploadImgObj?.userId}`,
  //     method: 'post',
  //     headers: {},
  //     data: uploadImgObj,
  //     signal: cancel
  //       ? cancelApiObject[this.get.name].handleRequestCancellation().signal
  //       : undefined,
  //   })
  //   console.log('response', response)

  //   return response.data
  // },
  eventsSavedUserId: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/event/all/viewsaved/${reqObj.userId}`,
      // url: `/v1/event/all/saved/past/paginated/view`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventSelectUnsavedEventId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/unsaved`,
      method: 'put',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventsGoingPastUserId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/going/past/${uploadImgObj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventsSavedUpcomingUserId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/saved/upcoming/${uploadImgObj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventSelectSaveEventId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/saved`,
      method: 'put',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventsGoingUpcomingUserId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/going/upcoming/${uploadImgObj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventSelectNotinterestedEventId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/notinterested`,
      method: 'put',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventsInterestedUserId: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      // url: `/v1/events/past/interected/${reqObj.userId}`,
      url: `/v1/event/all/viewinterested/${reqObj.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventsPastUserId: async function (reqObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/events/past/interected/${reqObj.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: reqObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  eventsInterestedUpcomingUserId: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `  /v1/events/interested/upcoming/${uploadImgObj?.userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
}
// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(EventApis)
